var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link"},[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.label)+" "),(_vm.dir == 'ltr')?_c('arrow-right-icon'):(_vm.dir == 'rtl')?_c('arrow-left-icon'):_vm._e(),_c('arrow-icon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }